import React from 'react';

const VideoCameraIcon: React.FC<{ size?: number; color?: string }> = ({ size = 24, color = '#999' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="7" width="13" height="10" rx="2" stroke={color} strokeWidth="2" fill="none" />
    <path d="M16 9.5L21 7V17L16 14.5" stroke={color} strokeWidth="2" strokeLinejoin="round" fill="none" />
    <circle cx="7.5" cy="12" r="1.5" fill={color} />
  </svg>
);

export default VideoCameraIcon; 